import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const Education = () => {
  return (
    <div 
      className="min-h-screen py-8 px-4"
      style={{
        background: `
          radial-gradient(900px 600px at 10% 10%, #132552 0%, #0B1736 45%, #060f24 100%)
        `
      }}
    >
      <main className="max-w-7xl mx-auto">
        <Link to="/">
          <Button variant="ghost" className="mb-6 mt-2">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Home
          </Button>
        </Link>

        <div className="border border-[hsl(var(--line))] rounded-[14px] p-4 sm:p-6 md:p-12" style={{ boxShadow: "0 10px 30px rgba(0, 0, 0, 0.35)" }}>
          <h1 className="font-orbitron font-bold text-3xl sm:text-4xl md:text-5xl mb-6 leading-tight">
            Education <span className="text-primary">Automation</span>
          </h1>

          <section className="mb-10 md:mb-12">
            <h2 className="font-orbitron font-bold text-xl sm:text-2xl mb-4">The Challenge</h2>
            <p className="text-base sm:text-lg text-muted-foreground mb-4 leading-relaxed">
              Schools, universities, and training facilities need consistent cleaning across large campuses while managing tight budgets. Student health and safety depend on spotless environments, but custodial costs continue to rise.
            </p>
          </section>

          <section className="mb-10 md:mb-12">
            <h2 className="font-orbitron font-bold text-xl sm:text-2xl mb-4">The Solution</h2>
            <p className="text-base sm:text-lg text-muted-foreground mb-6 leading-relaxed">
              Our Education Bundle uses CC1 Pro for autonomous floor cleaning in hallways, cafeterias, and common areas, plus AI Voice for parent inquiries and administrative support.
            </p>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="border border-[hsl(var(--line))] glass-effect p-6 rounded-xl">
                <h3 className="font-orbitron font-bold text-lg mb-2">CC1 Pro Cleaning</h3>
                <p className="text-sm text-muted-foreground">Scheduled cleaning of hallways, libraries, and cafeterias between classes</p>
                <p className="text-primary font-bold mt-2 text-sm">Safe around students</p>
              </div>
              
              <div className="border border-[hsl(var(--line))] glass-effect p-6 rounded-xl">
                <h3 className="font-orbitron font-bold text-lg mb-2">Smart Scheduling</h3>
                <p className="text-sm text-muted-foreground">Cleans during off-hours or low-traffic periods automatically</p>
                <p className="text-primary font-bold mt-2 text-sm">Zero disruption</p>
              </div>
              
              <div className="border border-[hsl(var(--line))] glass-effect p-6 rounded-xl">
                <h3 className="font-orbitron font-bold text-lg mb-2">AI Voice Support</h3>
                <p className="text-sm text-muted-foreground">Handle parent inquiries, enrollment questions, and appointment scheduling</p>
                <p className="text-primary font-bold mt-2 text-sm">24/7 availability</p>
              </div>
            </div>
          </section>

          <section className="mb-10 md:mb-12">
            <h2 className="font-orbitron font-bold text-xl sm:text-2xl mb-4">Results You Can Expect</h2>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold">✓</span>
                <span className="text-muted-foreground">Maintain cleanliness during flu season and high-traffic periods</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold">✓</span>
                <span className="text-muted-foreground">Reduce custodial costs by $3,000–$6,000/month</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold">✓</span>
                <span className="text-muted-foreground">Free custodial staff for specialized cleaning and maintenance</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-bold">✓</span>
                <span className="text-muted-foreground">Improve parent satisfaction with responsive communication</span>
              </li>
            </ul>
          </section>

          <section className="text-center">
            <h2 className="font-orbitron font-bold text-xl sm:text-2xl mb-4 leading-tight">Create a Cleaner Learning Environment</h2>
            <p className="text-base sm:text-lg text-muted-foreground mb-6 max-w-2xl mx-auto leading-relaxed">
              Invest in student health and safety while reducing operational costs.
            </p>
            <Button 
              asChild
              size="lg"
              className="bg-primary text-primary-foreground hover:bg-primary/90 font-extrabold rounded-xl"
            >
              <a href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" target="_blank" rel="noopener noreferrer">
                Schedule Education Demo
              </a>
            </Button>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Education;
